export const SAVE = 'personalAccidentSCTIStep.SAVE';
export const VALUE_CHANGED = 'personalAccidentSCTIStep.VALUE_CHANGED';
export const LOAD = 'personalAccidentSCTIStep.VALUE_LOAD';
export const NEXT = 'personalAccidentSCTIStep.NEXT';
export const RESET = 'personalAccidentSCTIStep.RESET';
export const RESET_DAMAGED_LOST_EXPENSE = 'personalAccidentSCTIStep.RESET_DAMAGED_LOST_EXPENSE';
export const RESET_DELAYED_LUGGAGE_EXPENSE = 'personalAccidentSCTIStep.RESET_DELAYED_LUGGAGE_EXPENSE';
export const RESET_COMPENSATION = 'personalAccidentSCTIStep.RESET_COMPENSATION';
//--------------------------------------------------------
export const RESET_PERSONAL_ACCIDENT_STATE = 'personalAccidentSCTIStep.RESET_PERSONAL_ACCIDENT_STATE';
export const RESET_PERSONAL_ACCIDENT_INJURY_STATE = 'personalAccidentSCTIStep.RESET_PERSONAL_ACCIDENT_INJURY_STATE';
export const RESET_PERSONAL_ACCIDENT_INJURY_LEAVE_PERMANENTLY_STATE = 'personalAccidentSCTIStep.RESET_PERSONAL_ACCIDENT_INJURY_LEAVE_PERMANENTLY_STATE';
export const RESET_PERSONAL_ACCIDENT_INJURY_RESULT_STATE = 'personalAccidentSCTIStep.RESET_PERSONAL_ACCIDENT_INJURY_RESULT_STATE';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '20',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.PersonalAccident/constants.js